__turbopack_context__.v({
  "active": "QG4Nqa_active",
  "icon": "QG4Nqa_icon",
  "root": "QG4Nqa_root",
  "wider": "QG4Nqa_wider",
});
